import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { User } from 'models'
import { getAuthToken } from 'hooks/AuthHooks'
import { toSnakeCase } from 'utils/snakeCase'
import { toCamelCase } from 'utils/camelCase'
import {
  BaseQueryFn,
  FetchArgs,
  FetchBaseQueryError,
  FetchBaseQueryMeta,
} from '@reduxjs/toolkit/query'

const baseQuery = fetchBaseQuery({
  baseUrl: process.env.REACT_APP_API_V2_URL,
  prepareHeaders: async (headers) => {
    const token = await getAuthToken()
    if (token) {
      headers.set('Authorization', `Bearer ${token}`)
    }
    return headers
  },
})

export const baseQueryWithCaseTransform: BaseQueryFn<
  string | FetchArgs,
  unknown,
  FetchBaseQueryError,
  {},
  FetchBaseQueryMeta
> = async (args, api, extraOptions) => {
  let transformedArgs = args
  if (args && typeof args === 'object' && 'body' in args) {
    transformedArgs = { ...args, body: toSnakeCase(args.body) }
  }

  const result = await baseQuery(transformedArgs, api, extraOptions)

  if (result.data) {
    result.data = toCamelCase(result.data)
  }

  return result
}

interface GetProfileParams {
  storeid?: string
}

const userApi = createApi({
  reducerPath: 'userApi',
  baseQuery: baseQueryWithCaseTransform,
  endpoints: (builder) => ({
    getProfile: builder.query<User, GetProfileParams>({
      query: (params) => ({
        url: '/user-profiles',
        params: {
          storeid: params?.storeid,
        },
      }),
    }),
    updateProfile: builder.mutation<User, Partial<User>>({
      query: (userData) => ({
        url: '/user-profiles',
        method: 'PUT',
        body: userData,
      }),
    }),
  }),
})

export const {
  useGetProfileQuery,
  useLazyGetProfileQuery,
  useUpdateProfileMutation,
} = userApi
export default userApi
